export const breakpoints = {
  xxs: 0,
  xs: 575,
  sm: 767,
  md: 991,
  lg: 1199,
  xl: 1439,
  xxl: 1829
}

const theme = ({ colorScheme }) => {
  return {
    font: {
      primary: 'Poppins, sans-serif',
      secondary: 'Lora, sans-serif'
    },
    color: {
      body: colorScheme === 'DARK' ? '#000000' : '#ffffff',
      global: colorScheme === 'DARK' ? '#ffffff' : '#000000',
      inverted: colorScheme === 'DARK' ? '#ffffff' : '#000000',
      primary: '#9B6547',
      light: '#FFF2E5',
      white: '#ffffff',
      black: '#000000',
      red: '#E14747',
      line: colorScheme === 'DARK' ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.15)',
      lineDark: 'rgba(0,0,0,0.15)',
      lineInverted: 'rgba(0,0,0,0.15)',
      pressed: 'rgba(255,255,255,0.075)',
      pressedInverted: 'rgba(0,0,0,0.06)'
    },
    colorScheme
  }
}

export default theme
